<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="option-wrap">
      <Select v-model="search.status" style="width: 150px;" @on-change="loadData">
        <Option value="">全部</Option>
        <Option :value="1">已通过</Option>
        <Option :value="2">已拒绝</Option>
        <Option :value="0">待处理</Option>
      </Select>
    </div>
    <Table :loading="tableLoading" class="spacingTwice" border :columns="columns" :data="dataList"></Table>
    <Page v-show="total > 10" show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
    <Modal :mask-closable="false"
           v-model="checkdata"
           title="审核驳回"
           :loading="loading"
           @on-ok="editData('formValidate')">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="驳回理由" prop="reason">
          <Input type="textarea" placeholder="请输入驳回理由，限制50字" v-model="formValidate.aduit_con" maxlength="50" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import https from '../../https'
import utils from '../../utils'
export default {
  name: 'checkCertification',
  data () {
    return {
      loading: true,
      tableLoading: true,
      checkdata: false,
      authorized: false,
      selectItems: [],
      sdkVersion: [],
      // check: [
      //   { name: '待审核', val: 1 },
      //   { name: '审核通过', val: 2 },
      //   { name: '未通过审核', val: 3 }
      // ],
      check: [
        { name: '待审核', val: 0 },
        { name: '审核通过', val: 1 },
        { name: '审核驳回', val: 2 }
      ],
      search: {
        stats: 9
      },
      formValidate: {
        status: '',
        aduit_con: ''
      },
      ruleValidate: {
        aduit_con: [
          { required: true, message: '请输入应用名称', trigger: 'blur' },
          { type: 'string', max: 50, message: '最多输入50个字', trigger: 'blur' }
        ]
      },
      dataSource: [], // table数据源
      columns: [ // table表格
        {
          title: '资质名称',
          key: 'name',
          minWidth: 150,
          align: 'center'
        },
        {
          title: '身份证号码',
          key: 'idno',
          minWidth: 200
        },
        {
          title: '电话',
          key: 'mobile',
          align: 'center',
          width: 150
        },
        {
          title: '邮箱',
          key: 'email',
          align: 'center',
          minWidth: 200
        },
        {
          title: '审核状态',
          key: 'status',
          width: 130,
          align: 'center',
          render: (h, params) => {
            let checked = ''
            this.check.forEach(n => {
              if (n.val === params.row.status) checked = n.name
            })
            let html = [
              h('span', checked)
            ]
            return h('div', html)
          }
        },
        {
          title: '提交时间',
          key: 'updated_at',
          align: 'center',
          width: 200
        },
        {
          title: '操作',
          width: 250,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small',
                  disabled: params.row.status === 1 || params.row.status === 2
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.editId = params.row.id
                    this.formValidate.status = 1
                    this.editData('formValidate')
                  }
                }
              }, '通过'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: params.row.status === 1 || params.row.status === 2
                },
                on: {
                  click: () => {
                    this.checkdata = true
                    this.formValidate.status = 2
                    this.editId = params.row.id
                  }
                }
              }, '拒绝')
            ])
          }
        }
      ],
      tvpList: [],
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1 // 当前页
    }
  },
  components: {
    breadcrumb
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.loadData()
  },
  methods: {
    formatDay: utils.formatDay,
    // 加载tabs列表
    loadData () {
      https.request({
        method: 'get',
        // url: '/v1/check/qualification',
        url: '/v2/es/audit/developers',
        params: this.search
      }).then(res => {
        this.tableLoading = false
        this.dataSource = res.data.items || []
        this.setData()
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    // 数据静态分页
    setData () {
      this.dataList = []
      this.total = this.dataSource.length
      for (let i = (this.current - 1) * this.pageSize; i < this.current * this.pageSize; i++) {
        if (i === this.total) return false
        this.dataList.push(this.dataSource[i])
      }
    },
    // 表格排序
    sortChange (data) {
      if (data.order !== 'normal') {
        this.sort = [data.key, data.order].join(' ')
        this.loadData()
      }
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    // 每页条数控制
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    editData (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.changeLoading()
            let params = {
              status: this.formValidate.status,
              id: this.editId
            }
            if (this.formValidate.status === 2) {
              params.aduit_con = this.formValidate.aduit_con
            }
            console.log(params)
            https.request({
              method: 'put',
              url: '/v2/es/audit/developer',
              data: params
            }).then(res => {
              if (res.code === 400) {
                this.$Message.error(res.message)
              } else {
                this.$Message.success('提交成功')
              }
              this.checkdata = false
              this.loadData()
            }).catch(error => {
              this.$Message.error(error)
            })
          }, 1000)
        } else {
          this.changeLoading()
        }
      })
    },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .file-wrap {
    position: relative;
    display: inline-block;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/check/checkIndividual.vue